export interface Industry {
  imageUrl: string;
  screenUrl: string;
  title: string;
  description: string;
  link: string;
}

export const INDUSTRIES: Industry[] = [
  {
    imageUrl: "/qsr-bg.ez88PgZwP2-u.webp",
    screenUrl: "/qsr-screen.GP3Xxuf91oYQ.webp",
    title: "QSR / Restaurants",
    description: "Drive more sales with digital menu boards",
    link: "/industries/restaurant-digital-signage-software",
  },
  {
    imageUrl: "/corporate-bg.HhZW9crJEy0a.webp",
    screenUrl: "/corporate-screen.8uIYz7iF1fJV.webp",
    title: "Corporate Communication",
    description: "Run employee engagement & branding exercise",
    link: "/industries/corporate-digital-signage-software",
  },
  {
    imageUrl: "/retail-bg.OCVyJmpF3L4m.webp",
    screenUrl: "/retail-screen.2oqprl0tW8Ln.webp",
    title: "Retail Units",
    description: "Present your products for better engagement & sales",
    link: "/industries/retail-digital-signage-software",
  },
  {
    imageUrl: "/beauty-bg.8xJlMNqBS93U.webp",
    screenUrl: "/beauty-screen.jfB7j_BVQeb-.webp",
    title: "Beauty & Spa",
    description: "Increase sales by turning passerby audience into customers",
    link: "/industries/beauty-salon-digital-signage-software",
  },
  {
    imageUrl: "/financial-bg.RDT5tgCzcc21.webp",
    screenUrl: "/financial-screen.tj4ExvYJcYWC.webp",
    title: "Financial Institutions",
    description: "Create awareness about financial services & schemes with dynamic visual contents",
    link: "/industries/finance-digital-signage-software",
  },
  {
    imageUrl: "/manufacturin-bg.aVNS8eAAFmWF.webp",
    screenUrl: "/manufacturin-screen.3cZPWbUFVcJW.webp",
    title: "Manufacturing Units",
    description: "Notify & keep the employees updated with company policies & announcements.",
    link: "/industries/manufacturing-digital-signage-software",
  },
  {
    imageUrl: "/education-bg.nkQ4NnBhLQ8x.webp",
    screenUrl: "/education-screen.RFJMyoOr5f-x.webp",
    title: "Education",
    description: "Create a learning experience that impacts and enhances student engagement",
    link: "/industries/education-digital-signage-software",
  },
  {
    imageUrl: "/fitness-bg.yHF5ok8PjoyW.webp",
    screenUrl: "/fitness-screen.Y7K0ScM7Z0K8.webp",
    title: "Gym & Fitness",
    description: "Keep the trainees in track and create engaging experience",
    link: "/industries/fitness-digital-signage-software",
  },
  {
    imageUrl: "/transport-bg.pF8eoyizpuXR.webp",
    screenUrl: "/transport-screen.X1gyJOPlFie2.webp",
    title: "Transportation",
    description: "Deliver real-time information to travelers.",
    link: "/industries/transportation-digital-signage-software",
  },
  {
    imageUrl: "/hospitality-bg.r1MguaXDuR5s.webp",
    screenUrl: "/hospitality-screen.QVU4QDOuzyOd.webp",
    title: "Hospitality",
    description: "Deliver a wide range of content in guest rooms, bars & lobbies.",
    link: "/industries/hospitality-digital-signage-software",
  },
  {
    imageUrl: "/healthcare-bg.RVIBzccasVOk.webp",
    screenUrl: "/healthcare-screen.MoJcvYDUhG2k.webp",
    title: "Healthcare",
    description: "Educate and empower your patients, visitors and staffs",
    link: "/industries/healthcare-digital-signage-software",
  },
];

export function getIndustries(): Industry[] {
  return INDUSTRIES;
}

export function getIndustryByTitle(title: string): Industry | undefined {
  return INDUSTRIES.find(industry => industry.title.toLowerCase() === title.toLowerCase());
}
